export const ThirdLinkConfig = {
  AE: {
    store: 'aliexpress',
    area: 'common',
  },
  AT: {
    store: 'amazon',
    area: 'DE',
  },
  BE: {
    store: 'amazon',
    area: 'DE',
  },
  BG: {
    store: 'amazon',
    area: 'DE',
  },
  BR: {
    store: 'aliexpress',
    area: 'common',
  },
  CY: {
    store: 'aliexpress',
    area: 'common',
  },
  CZ: {
    store: 'amazon',
    area: 'DE',
  },
  DE: {
    store: 'amazon',
    area: 'DE',
  },
  DK: {
    store: 'amazon',
    area: 'DE',
  },
  EE: {
    store: 'amazon',
    area: 'DE',
  },
  ES: {
    store: 'amazon',
    area: 'ES',
  },
  FI: {
    store: 'amazon',
    area: 'DE',
  },
  FR: {
    store: 'amazon',
    area: 'FR',
  },
  GB: {
    store: 'amazon',
    area: 'GB',
  },
  GR: {
    store: 'aliexpress',
    area: 'common',
  },
  HR: {
    store: 'amazon',
    area: 'DE',
  },
  HU: {
    store: 'aliexpress',
    area: 'common',
  },
  ID: {
    store: 'aliexpress',
    area: 'common',
  },
  IE: {
    store: 'amazon',
    area: 'DE',
  },
  IL: {
    store: 'aliexpress',
    area: 'common',
  },
  IT: {
    store: 'amazon',
    area: 'IT',
  },
  JP: {
    store: 'amazon',
    area: 'JP',
  },
  KR: {
    store: 'aliexpress',
    area: 'common',
  },
  LT: {
    store: 'amazon',
    area: 'DE',
  },
  LU: {
    store: 'amazon',
    area: 'DE',
  },
  LV: {
    store: 'amazon',
    area: 'DE',
  },
  MT: {
    store: 'aliexpress',
    area: 'common',
  },
  MY: {
    store: 'lazada',
    area: 'MY',
  },
  NL: {
    store: 'amazon',
    area: 'DE',
  },
  PH: {
    store: 'lazada',
    area: 'PH',
  },
  PL: {
    store: 'amazon',
    area: 'DE',
  },
  PT: {
    store: 'aliexpress',
    area: 'common',
  },
  RO: {
    store: 'aliexpress',
    area: 'common',
  },
  RU: {
    store: 'aliexpress',
    area: 'common',
  },
  SE: {
    store: 'aliexpress',
    area: 'common',
  },
  SG: {
    store: 'lazada',
    area: 'SG',
  },
  SI: {
    store: 'aliexpress',
    area: 'common',
  },
  SK: {
    store: 'aliexpress',
    area: 'common',
  },
  TH: {
    store: 'lazada',
    area: 'TH',
  },
  US: {
    store: 'amazon',
    area: 'US',
  },
  CN: {
    store: 'tmall',
    area: 'CN',
  },
  VN: {
    store: 'lazada',
    area: 'VN',
  },
};

export const LocalLang = {
  de_de: {
    'error.500.lazada.description': '',
    'error.500.tmall.title': '',
    'error.500.others.title': '',
    'error.500.tmall.description': '',
    'error.500.others.redirectBtn': '',
    'error.500.aliExpress.title': '',
    'error.500.amazon.description':
      "Unsere Website wird vorübergehend gewartet. Wenn Sie einen Kauf tätigen müssen, können Sie auf die Schaltfläche unten klicken, um zu unserem Amazon-Shop zu gelangen. Sie können uns auch eine E-Mail an <a href='mailto:ecommerce@insta360.com'>ecommerce@insta360.com</a> senden, um weitere Unterstützung zu erhalten. Danke für Ihr Verständnis.",
    'error.500.amazon.redirectBtn': 'AUF AMAZON EINKAUFEN',
    'error.500.tmall.redirectBtn': '',
    'error.500.lazada.redirectBtn': '',
    'error.500.aliExpress.description': '',
    'error.500.amazon.title': 'Entschuldigung!',
    'error.500.lazada.title': '',
    'error.500.others.description':
      "Our website is temporarily under maintenance. \nIf you need to make a purchase, please contact our customer service at <a href='mailto:ecommerce@insta360.com'>ecommerce@insta360.com</a> and we will recommend you an alternative purchase link according to your region. Thank you for your understanding.",
    'error.500.aliExpress.redirectBtn': '',
  },
  en_us: {
    'error.500.lazada.description':
      "Our website is temporarily under maintenance. If you need to make a purchase, you can click the button below to go to our Lazada store. You may also email us at <a href='mailto:ecommerce@insta360.com'>ecommerce@insta360.com</a> for further assistance. Thank you for your understanding.",
    'error.500.tmall.title': '',
    'error.500.others.title': 'Sorry!',
    'error.500.tmall.description': '',
    'error.500.others.redirectBtn': 'Official Website',
    'error.500.aliExpress.title': 'Sorry!',
    'error.500.amazon.description':
      "Our website is temporarily under maintenance. If you need to make a purchase, you can click the button below to go to our Amazon store. You may also email us at <a href='mailto:ecommerce@insta360.com'>ecommerce@insta360.com</a> for further assistance. Thank you for your understanding.",
    'error.500.amazon.redirectBtn': 'BUY NOW ON AMAZON',
    'error.500.tmall.redirectBtn': '',
    'error.500.lazada.redirectBtn': 'BUY NOW ON LAZADA',
    'error.500.aliExpress.description':
      "Our website is temporarily under maintenance. If you need to make a purchase, you can click the button below to go to our AliExpress store. You may also email us at <a href='mailto:ecommerce@insta360.com'>ecommerce@insta360.com</a> for further assistance. Thank you for your understanding.",
    'error.500.amazon.title': 'Sorry!',
    'error.500.lazada.title': 'Sorry！',
    'error.500.others.description':
      "Our website is temporarily under maintenance. \nIf you need to make a purchase, please contact our customer service at <a href='mailto:ecommerce@insta360.com'>ecommerce@insta360.com</a> and we will recommend you an alternative purchase link according to your region. Thank you for your understanding.",
    'error.500.aliExpress.redirectBtn': 'BUY ON ALIEXPRESS',
  },
  es_es: {
    'error.500.lazada.description': '',
    'error.500.tmall.title': '',
    'error.500.others.title': '',
    'error.500.tmall.description': '',
    'error.500.others.redirectBtn': '',
    'error.500.aliExpress.title': '',
    'error.500.amazon.description':
      "Nuestro sitio web se encuentra temporalmente en mantenimiento. Si necesita realizar una compra, puede hacer clic en el botón a continuación para ir a nuestra tienda de Amazon. También puede enviarnos un correo electrónico a <a href='mailto:ecommerce@insta360.com'>ecommerce@insta360.com</a> para obtener más ayuda. Gracias por su comprensión.",
    'error.500.amazon.redirectBtn': 'COMPRAR EN AMAZON',
    'error.500.tmall.redirectBtn': '',
    'error.500.lazada.redirectBtn': '',
    'error.500.aliExpress.description': '',
    'error.500.amazon.title': '¡Disculpe!',
    'error.500.lazada.title': '',
    'error.500.others.description':
      "Our website is temporarily under maintenance. \nIf you need to make a purchase, please contact our customer service at <a href='mailto:ecommerce@insta360.com'>ecommerce@insta360.com</a> and we will recommend you an alternative purchase link according to your region. Thank you for your understanding.",
    'error.500.aliExpress.redirectBtn': '',
  },
  fr_fr: {
    'error.500.lazada.description': '',
    'error.500.tmall.title': '',
    'error.500.others.title': '',
    'error.500.tmall.description': '',
    'error.500.others.redirectBtn': '',
    'error.500.aliExpress.title': '',
    'error.500.amazon.description':
      "Notre site web est temporairement en maintenance. Si vous devez effectuer un achat, vous pouvez cliquer sur le bouton ci-dessous pour accéder à notre boutique Amazon. Vous pouvez également nous envoyer un e-mail à <a href='mailto:ecommerce@insta360.com'>ecommerce@insta360.com</a> pour obtenir de l'aide. Merci pour votre compréhension.",
    'error.500.amazon.redirectBtn': 'ACHETER SUR AMAZON',
    'error.500.tmall.redirectBtn': '',
    'error.500.lazada.redirectBtn': '',
    'error.500.aliExpress.description': '',
    'error.500.amazon.title': 'Désolé!',
    'error.500.lazada.title': '',
    'error.500.others.description':
      "Our website is temporarily under maintenance. \nIf you need to make a purchase, please contact our customer service at <a href='mailto:ecommerce@insta360.com'>ecommerce@insta360.com</a> and we will recommend you an alternative purchase link according to your region. Thank you for your understanding.",
    'error.500.aliExpress.redirectBtn': '',
  },
  it_it: {
    'error.500.lazada.description': '',
    'error.500.tmall.title': '',
    'error.500.others.title': '',
    'error.500.tmall.description': '',
    'error.500.others.redirectBtn': '',
    'error.500.aliExpress.title': '',
    'error.500.amazon.description':
      "Il nostro sito Web è temporaneamente in manutenzione. Se devi effettuare un acquisto, puoi fare clic sul pulsante in basso per accedere al nostro negozio Amazon. Puoi anche inviarci un'e-mail all'indirizzo <a href='mailto:ecommerce@insta360.com'>ecommerce@insta360.com</a> per ulteriore assistenza. Grazie per la vostra comprensione.",
    'error.500.amazon.redirectBtn': 'ACQUISTA SU AMAZON',
    'error.500.tmall.redirectBtn': '',
    'error.500.lazada.redirectBtn': '',
    'error.500.aliExpress.description': '',
    'error.500.amazon.title': 'Scusa!',
    'error.500.lazada.title': '',
    'error.500.others.description':
      "Our website is temporarily under maintenance. \nIf you need to make a purchase, please contact our customer service at <a href='mailto:ecommerce@insta360.com'>ecommerce@insta360.com</a> and we will recommend you an alternative purchase link according to your region. Thank you for your understanding.",
    'error.500.aliExpress.redirectBtn': '',
  },
  ja_jp: {
    'error.500.lazada.description': '',
    'error.500.tmall.title': '',
    'error.500.others.title': '',
    'error.500.tmall.description': '',
    'error.500.others.redirectBtn': '',
    'error.500.aliExpress.title': '',
    'error.500.amazon.description':
      "当社のウェブサイトは一時的にメンテナンス中です。 購入する必要がある場合は、下のボタンをクリックして Amazon ストアにアクセスしてください 。 さらにサポートが必要な場合は、<a href='mailto:ecommerce@insta360.com'>ecommerce@insta360.com</a> までメールでお問い合わせください。 ご理解いただきありがとうございます。",
    'error.500.amazon.redirectBtn': 'アマゾンで今すぐ購入',
    'error.500.tmall.redirectBtn': '',
    'error.500.lazada.redirectBtn': '',
    'error.500.aliExpress.description': '',
    'error.500.amazon.title': '申し訳ございません！',
    'error.500.lazada.title': '',
    'error.500.others.description':
      "Our website is temporarily under maintenance. \nIf you need to make a purchase, please contact our customer service at <a href='mailto:ecommerce@insta360.com'>ecommerce@insta360.com</a> and we will recommend you an alternative purchase link according to your region. Thank you for your understanding.",
    'error.500.aliExpress.redirectBtn': '',
  },
  ko_kr: {
    'error.500.lazada.description': '',
    'error.500.tmall.title': '',
    'error.500.others.title': '',
    'error.500.tmall.description': '',
    'error.500.others.redirectBtn': '',
    'error.500.aliExpress.title': 'Sorry!',
    'error.500.amazon.description': '',
    'error.500.amazon.redirectBtn': '',
    'error.500.tmall.redirectBtn': '',
    'error.500.lazada.redirectBtn': '',
    'error.500.aliExpress.description':
      "Our website is temporarily under maintenance. If you need to make a purchase, you can click the button below to go to our AliExpress store. You may also email us at <a href='mailto:ecommerce@insta360.com'>ecommerce@insta360.com</a> for further assistance. Thank you for your understanding.",
    'error.500.amazon.title': '',
    'error.500.lazada.title': '',
    'error.500.others.description':
      "Our website is temporarily under maintenance. \nIf you need to make a purchase, please contact our customer service at <a href='mailto:ecommerce@insta360.com'>ecommerce@insta360.com</a> and we will recommend you an alternative purchase link according to your region. Thank you for your understanding.",
    'error.500.aliExpress.redirectBtn': 'BUY ON ALIEXPRESS',
  },
  zh_cn: {
    'error.500.lazada.description': '',
    'error.500.tmall.title': '抱歉!',
    'error.500.others.title': '',
    'error.500.tmall.description':
      "官方商城暂时处于维护状态不能访问。如果您需要购买，可以点击下面的按钮前往我们天猫旗舰店。您也可以发送电子邮件至<a href='mailto:ecommerce@insta360.com'>ecommerce@insta360.com</a>以获得进一步的帮助。谢谢您的理解。",
    'error.500.others.redirectBtn': '',
    'error.500.aliExpress.title': '',
    'error.500.amazon.description': '',
    'error.500.amazon.redirectBtn': '',
    'error.500.tmall.redirectBtn': '天猫旗舰店\n',
    'error.500.lazada.redirectBtn': '',
    'error.500.aliExpress.description': '',
    'error.500.amazon.title': '',
    'error.500.lazada.title': '',
    'error.500.others.description': '',
    'error.500.aliExpress.redirectBtn': '',
  },
  zh_tw: {
    'error.500.lazada.description': '',
    'error.500.tmall.title': '',
    'error.500.others.title': 'Sorry!',
    'error.500.tmall.description': '',
    'error.500.others.redirectBtn': 'Official Website',
    'error.500.aliExpress.title': '',
    'error.500.amazon.description': '',
    'error.500.amazon.redirectBtn': '',
    'error.500.tmall.redirectBtn': '',
    'error.500.lazada.redirectBtn': '',
    'error.500.aliExpress.description': '',
    'error.500.amazon.title': '',
    'error.500.lazada.title': '',
    'error.500.others.description':
      "Our website is temporarily under maintenance. \nIf you need to make a purchase, please contact our customer service at <a href='mailto:ecommerce@insta360.com'>ecommerce@insta360.com</a> and we will recommend you an alternative purchase link according to your region. Thank you for your understanding.",
    'error.500.aliExpress.redirectBtn': '',
  },
};
